import useActiveState from "../../lib/useActiveState";
import { useEffect, useRef, useState } from "react";
import { sysUrl } from "../../config";
import $ from "jquery";

export default (props) => {
  const [app] = useActiveState("app");
  const [load, setLoad] = useState();
  const ref = useRef(null);
  useEffect(() => {
    props.active && setLoad(true);
    if (props.active && ref.current) {
      ref.current.contentWindow.postMessage("onenter", "*");
    }
  }, [props.active]);

  const safeAreaBottom = $("#safeAreaInsetBottom").height();

  return load ? (
    <div
      className="welfare-index"
      // style={{
      //   paddingBottom: sessionStorage.getItem("jjAgentShow") ? "60px" : "20px",
      // }}
    >
      <iframe
        src={`${sysUrl}/home/welfare?username=${
          localStorage.getItem("username") || ""
        }&token=${localStorage.getItem("token") || ""}&brand=${
          app.brand
        }&agent=${
          localStorage.getItem("agent") || "x7z1"
        }&safearea=${safeAreaBottom}`}
        ref={ref}
      />
    </div>
  ) : null;
};
